module.exports = __webpack_public_path__ + "static/giftingPlain-604388f3e3ef6a65dbed8d0198644619.jpg";